//
// $FlowFixMe
import styled from 'styled-components';
import { MEDIA_BREAK } from 'src/components/layout';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  flex: 1 0 auto;
  padding: 0 24px 24px;
  align-items: center;
`;

export const H1 = styled.div`
  font-family: Lato;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: center;
  color: #1d1e2b;
  margin: 10px;
`;

export const Action = styled.div`
  display: flex;
  margin: 20px;

  .closeButton {
    margin-right: 10px;
  }

  @media (max-width: ${MEDIA_BREAK}px) {
    flex-direction: column-reverse;
    .closeButton {
      margin-top: 10px;
    }
  }
`;
